
    <p>
        {{ textoInicial }}<span class="btnTermos"  (click)="abrirModal($event)">{{ textoLink }}</span>{{ textoFinal }}
    </p>
